module.exports = __webpack_public_path__ + "media/dog-profile-avatars/single-border-terrier-89791ab8.svg";